<template>
    <div id="editor_left">
        <editorLongNoveloutline v-if="textoroutline == 0"></editorLongNoveloutline>
        <editorLongText v-if="textoroutline == 1"></editorLongText>
    </div>
</template>
<script>
import editorLongNoveloutline from '@/components/long_novel/chapter/editor_long_noveloutline.vue' //编辑大纲
import editorLongText from '@/components/long_novel/chapter/editor_long_text.vue' //编辑章纲，正文
export default {
    components: {
        editorLongNoveloutline, editorLongText
    },
    data() {
        return {
            textoroutline: 0,
        }
    },
    created() {
        let editItem = JSON.parse(sessionStorage.getItem('editItem'))
        if (editItem.editType) {
            this.textoroutline = 0
        } else if (editItem.editText) {
            this.textoroutline = 1
        }
    }
}
</script>

<style>
#editor_left {
    flex: 1;
    height: 100%;
    margin-right: 15px;
}
</style>